import React, { Component } from "react";
import Script from 'react-load-script';
import {
    Button,
    Card,
    CardBody,
    Collapse,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Input,
    InputGroup,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    UncontrolledDropdown
} from "reactstrap";
import { NotificationManager } from "../../../../components/common/react-notifications";

import { Colxx, Separator } from "../../../../components/common/CustomBootstrap";
import { firestore } from '../../../../helpers/Firebase';
import { connect } from "react-redux";

import axios from 'axios';
import { getCenter } from "geolib";
import Switch from "rc-switch";
import "rc-switch/assets/index.css";
import Resizer from 'react-image-file-resizer';
import ImageUploader from 'react-images-upload';
import Select from 'react-select';
import { createNotification, getPlaceId, makeid, uploadPicture } from "../../../../helpers/Utils";
import Map from './map';

class Start extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collaps: {},
            openVideo: false,
            list: null,
            search: '',
            loading: false,
            fetchingCoordinates: false,
            pictures: {}

        };
        this.handleScriptLoad = this.handleScriptLoad.bind(this);
        this.handlePlaceSelect = this.handlePlaceSelect.bind(this);
        this.onDrop = this.onDrop.bind(this);

    }

    onDrop = (picture, fieldKey) => {
        if (picture.length) {
            let lastPic = picture[picture.length - 1];

            // First, create a preview URL for immediate display
            const previewUrl = URL.createObjectURL(lastPic);

            Resizer.imageFileResizer(
                lastPic,
                1080,
                1080,
                'jpeg',
                80,
                0,
                uri600 => {
                    const newPicture = {
                        name: '600',
                        data: uri600,
                        fieldKey: fieldKey,
                        preview: previewUrl
                    };

                    // Update pictures state with field-specific images and update list for preview
                    this.setState(prevState => {
                        const updatedList = { ...prevState.list };
                        updatedList[fieldKey] = previewUrl;

                        return {
                            pictures: {
                                ...prevState.pictures,
                                [fieldKey]: [newPicture]
                            },
                            list: updatedList
                        };
                    });
                },
                'blob'
            );
        } else {
            // Remove the specific field from pictures state and clear from list
            this.setState(prevState => {
                const newPictures = { ...prevState.pictures };
                delete newPictures[fieldKey];

                const updatedList = { ...prevState.list };
                delete updatedList[fieldKey];

                return {
                    pictures: newPictures,
                    list: updatedList
                };
            });
        }
    }

    componentWillReceiveProps(prop) {
        if (prop.selectedOutlet !== this.props.selectedOutlet) {
            this.getList(prop.selectedOutlet)
        }
    }
    componentWillMount() {
        let { selectedOutlet } = this.props
        if (selectedOutlet && selectedOutlet.key) {
            this.getList(selectedOutlet)
        }
    }
    componentWillUnmount() {
        // Cleanup preview URLs to prevent memory leaks
        this.cleanupPreviewURLs();
    }

    cleanupPreviewURLs() {
        // Cleanup preview URLs to prevent memory leaks
        const { pictures } = this.state;
        Object.keys(pictures || {}).forEach(fieldKey => {
            const fieldPictures = pictures[fieldKey];
            if (fieldPictures && fieldPictures.length > 0 && fieldPictures[0]?.preview) {
                URL.revokeObjectURL(fieldPictures[0].preview);
            }
        });
    }

    getList(selectedOutlet) {

        let key = selectedOutlet.key

        firestore().collection('washers').doc(key).collection('locations').get().then(results => {
            let locations = {}
            results.forEach(list => {

                let data = list.data()
                data.id = list.id
                locations[list.id] = data
            })

            // Filter onsite locations if SP has onsiteServicesEnabled disabled
            const { provider } = this.props || {};
            const spId = selectedOutlet?.sp_id;
            const serviceProvider = provider?.[spId];

            // If onsiteServicesEnabled is explicitly false, filter out onsite locations
            // Default to true (show onsite) if not set
            if (serviceProvider && serviceProvider.onsiteServicesEnabled === false) {
                const filteredLocations = {};
                Object.keys(locations).forEach(locKey => {
                    if (locations[locKey].type !== 'onsite') {
                        filteredLocations[locKey] = locations[locKey];
                    }
                });
                locations = filteredLocations;
            }

            // If quickWashServicesEnabled is explicitly false, filter out quick wash locations
            if (serviceProvider && serviceProvider.quickWashServicesEnabled === false) {
                const filteredLocations = {};
                Object.keys(locations).forEach(locKey => {
                    if (locations[locKey].type !== 'quickWash') {
                        filteredLocations[locKey] = locations[locKey];
                    }
                });
                locations = filteredLocations;
            }

            this.setState({ locations })

        })
    }


    searchId(object, id) {
        for (const key in object) {
            if (object?.[key]?.hasOwnProperty('areas_list')) {
                for (let i = 0; i < object?.[key]?.areas_list?.length; i++) {
                    if (object?.[key]?.areas_list?.[i]?.id === id) {
                        return object[key].areas_list[i];
                    }
                }
            }
        }
        return null;
    }
    render() {
        let { locations, list, selectedArea } = this.state
        return (
            <Card className="rounded">
                <CardBody>
                    <Row className="survey-app">
                        <Colxx xxs="12">
                            <div className="mb-2">
                                <h1>
                                    Locations
                                </h1>
                                <div className="text-zero top-right-button-container">
                                    <Button
                                        color="primary"
                                        className="btn-shadow"
                                        size="sm"
                                        onClick={() => this.setState({ list: {}, pictures: {} })}>Add Areas
                                    </Button>
                                </div>

                            </div>
                            <Separator className="mb-5" />
                            <Row>
                                <Colxx xxs="12" className="mb-3">
                                    {
                                        locations && Object.keys(locations).map(key => {
                                            let item = locations[key]

                                            return (
                                                <div key={key} className='rounded mb-4' style={{ boxShadow: 'none' }}>
                                                    <div className='d-flex justify-content-between m-4'>
                                                        <div>
                                                            <h3 >
                                                                {item.time.value + ' ' + item.time.label + (" Serving Areas")}
                                                            </h3>
                                                            <div className="mt-2 d-flex align-items-center">
                                                                {/* {item.capacity && (
                                                                    <span className="badge badge-pill badge-primary mr-2">
                                                                        Capacity: {item.capacity}
                                                                    </span>
                                                                )} */}
                                                                {item.type === 'onsite' && (
                                                                    <span className="badge badge-pill badge-secondary mr-2">
                                                                        Type: Onsite Serving Areas
                                                                    </span>
                                                                )}
                                                                {item.type === 'quickWash' && (
                                                                    <span className="badge badge-pill badge-primary mr-2">
                                                                        Quick Wash Location
                                                                    </span>
                                                                )}

                                                                {item.recoveryServiceEnabled && (
                                                                    <>
                                                                        <span className="badge badge-pill badge-success mr-2">
                                                                            Pickup & Dropoff: {item.pickupAndDropoffPrice ? `${item.pickupAndDropoffPrice} AED` : 'Free'}
                                                                        </span>
                                                                        {item.pickupOnlyPrice !== undefined && item.pickupOnlyPrice !== null && (
                                                                            <span className="badge badge-pill badge-info">
                                                                                Pickup Only: {item.pickupOnlyPrice ? `${item.pickupOnlyPrice} AED` : 'Free'}
                                                                            </span>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <Button style={{ margin: '4px' }} outline color='danger' onClick={() => this.setState({ confirmDelete: key })} size='xs'>Delete</Button>

                                                            <Button outline color='dark' onClick={() => {
                                                                const itemCopy = JSON.parse(JSON.stringify(item));
                                                                this.setState({
                                                                    list: itemCopy,
                                                                    pictures: itemCopy.locationImage ? { locationImage: itemCopy.locationImage } : {}
                                                                });
                                                            }} size='xs'>Edit</Button>
                                                        </div>
                                                    </div>
                                                    {
                                                        item.areas && Object.keys(item.areas).map(areaTitle => {
                                                            let areas = item.areas[areaTitle].list ? item.areas[areaTitle].list : item.areas[areaTitle]
                                                            return (
                                                                <div key={areaTitle} className="mb-2">
                                                                    <Row className='ml-5'>
                                                                        <h4>{areaTitle}</h4>
                                                                    </Row>
                                                                    <Collapse isOpen={true} className='ml-5'>
                                                                        {
                                                                            areas.map((area, i) => {
                                                                                return (
                                                                                    <Row key={i} className='ml-2 mb-2 d-flex align-items-center'>
                                                                                        <i className="simple-icon-location-pin  mr-1" />
                                                                                        <div className="mr-2">{area.name ? area.name : area}</div>
                                                                                        {area?.place_id && <Button outline color='primary' onClick={async () => {
                                                                                            let mapref = await firestore().collection('servingLocations').doc(area?.place_id).get()
                                                                                            if (mapref.exists) {
                                                                                                this.setState({ selectedArea: { ...area, pathCoordinates: mapref.data()?.geojson } })
                                                                                            } else {

                                                                                            }
                                                                                        }} size='xs'>Show On Map</Button>}
                                                                                    </Row>
                                                                                )
                                                                            })
                                                                        }

                                                                    </Collapse>
                                                                </div>

                                                            )
                                                        })
                                                    }
                                                    <Separator />
                                                </div>
                                            )
                                        })
                                    }
                                </Colxx>
                                {list && this.renderAddNew()}
                            </Row>
                            {
                                this.state.confirmDelete && <Modal isOpen={true}>
                                    <ModalBody>Are you sure you want to delete this area group?</ModalBody>
                                    <ModalFooter>
                                        <Button color='danger' onClick={() => this.setState({ confirmDelete: false })}>Cancel</Button>
                                        <Button onClick={() => this.deleteLoaction(this.state.confirmDelete)}>Confirm</Button>
                                    </ModalFooter>

                                </Modal>
                            }
                        </Colxx>
                    </Row>
                    {selectedArea && <Map selectedArea={selectedArea}
                        dismiss={() => this.setState({ selectedArea: false })}
                        addLocation={(newCoordinates) => {
                            const locationData = {
                                ...selectedArea.newLocation,
                                data: {
                                    ...selectedArea.newLocation?.data,
                                    geojson: {
                                        ...selectedArea.newLocation?.data?.geojson,
                                        coordinates: newCoordinates ? [newCoordinates] : selectedArea.newLocation?.data?.geojson?.coordinates,
                                        type: newCoordinates ? 'Polygon' : selectedArea.newLocation?.data?.geojson?.type
                                    }
                                }
                            };
                            this.addLocation(locationData);
                        }} />}
                </CardBody>
            </Card>
        )
    }
    deleteLoaction(locationsKey) {
        let { locations } = this.state
        let { selectedOutlet } = this.props

        let key = selectedOutlet.key

        firestore().collection('washers').doc(key).collection('locations').doc(locationsKey).delete().then(() => {
            let deletedlocations = locations?.[locationsKey]?.areas_list?.map(area => area.id);;
            if (deletedlocations?.length) {
                deletedlocations.map(async (r) => {
                    await firestore().collection('servingLocations').doc(r).update({ workers: firestore.FieldValue.arrayRemove(key), })
                })
            }
            delete locations[locationsKey]
            this.setState({ locations, confirmDelete: false }, () => {

                NotificationManager.success(
                    "",
                    "Area group deleted successfully",
                    4000,
                    null,
                    null,
                )
            })
        })
    }
    renderAddNew() {
        let { list, collaps } = this.state

        return (
            <Modal wrapClassName="modal-right"
                backdrop="static" isOpen={true}>
                <ModalHeader>
                    Add new Areas
                </ModalHeader>
                <ModalBody>
                    {(() => {
                        const { provider } = this.props || {};
                        const { selectedOutlet } = this.props;
                        const spId = selectedOutlet?.sp_id;
                        const serviceProvider = provider?.[spId];
                        const isOnsiteEnabled = serviceProvider?.onsiteServicesEnabled;
                        const isQuickWashEnabled = serviceProvider?.quickWashServicesEnabled;

                        const typeOptions = [
                            { value: 'normal', label: 'Normal' },
                            ...(isOnsiteEnabled ? [{ value: 'onsite', label: 'Onsite Serving Areas' }] : []),
                            ...(isQuickWashEnabled ? [{ value: 'quickWash', label: 'Quick Wash Location' }] : []),
                        ];

                        if (typeOptions.length <= 1) return null;

                        const currentType = list?.type || 'normal';
                        const selectedOption = typeOptions.find(o => o.value === currentType) || typeOptions[0];

                        return (
                            <div className='mb-4'>
                                <Label className={'m-0 mb-2'}>Location Type</Label>
                                <Select
                                    placeholder="Select location type"
                                    value={selectedOption}
                                    onChange={(opt) => {
                                        list.type = opt.value
                                        this.setState({ list })
                                    }}
                                    options={typeOptions}
                                    className="react-select"
                                    classNamePrefix="react-select"
                                />
                            </div>
                        );
                    })()}
                    {(() => {
                        const { provider } = this.props || {};
                        const { selectedOutlet } = this.props;
                        const spId = selectedOutlet?.sp_id;
                        const serviceProvider = provider?.[spId];
                        const isPPFEnabled = serviceProvider?.ppfServicesEnabled;

                        return isPPFEnabled && (
                            <>
                                <div className='mb-4'>
                                    <div className='d-flex align-items-center justify-content-between mb-2'>
                                        <Label className={'m-0'}>Enable Recovery Service for this location</Label>
                                        <Switch
                                            className="custom-switch custom-switch-primary"
                                            checked={list?.recoveryServiceEnabled || false}
                                            disabled={!isPPFEnabled}
                                            onChange={switchCheckedPrimary => {
                                                if (isPPFEnabled) {
                                                    list.recoveryServiceEnabled = switchCheckedPrimary
                                                    this.setState({ list })
                                                }
                                            }}
                                        />
                                    </div>

                                </div>
                                {list?.recoveryServiceEnabled && (
                                    <>
                                        <div className='mb-4'>
                                            <Label>Pickup and Dropoff Price (AED):</Label>
                                            <div className='text-muted mb-2' style={{ fontSize: '0.875rem' }}>
                                                Pickup and Dropoff price for the vehicle. Leave empty to make service free for users
                                            </div>
                                            <Input
                                                placeholder={'Enter price (leave empty for free)'}
                                                type='number'
                                                id='pickupAndDropoffPrice'
                                                value={list && list.pickupAndDropoffPrice}
                                                onChange={(e) => {
                                                    list.pickupAndDropoffPrice = e.target.value ? parseFloat(e.target.value) : null
                                                    this.setState({ list })
                                                }}
                                            />
                                        </div>
                                        <div className='mb-4'>
                                            <Label>Pickup Only Price (AED):</Label>
                                            <div className='text-muted mb-2' style={{ fontSize: '0.875rem' }}>
                                                Pickup only price for the vehicle. Leave empty to make service free for users
                                            </div>
                                            <Input
                                                placeholder={'Enter price (leave empty for free)'}
                                                type='number'
                                                id='pickupOnlyPrice'
                                                value={list && list.pickupOnlyPrice}
                                                onChange={(e) => {
                                                    list.pickupOnlyPrice = e.target.value ? parseFloat(e.target.value) : null
                                                    this.setState({ list })
                                                }}
                                            />
                                        </div>
                                    </>
                                )}
                                {!isPPFEnabled && (
                                    <div className='mb-4 text-muted' style={{ fontSize: '0.875rem' }}>
                                        Recovery service is only available for PPF service locations. PPF services are disabled for this Service Provider by admin.
                                    </div>
                                )}
                            </>
                        );
                    })()}

                    <div className='mb-4'>
                        <Label>
                            {"Select areas you serve"}
                        </Label>
                        <Script url="https://maps.googleapis.com/maps/api/js?key=AIzaSyCExglJjHXgXzSGHJB1NmLll7NgjOG8_bc&libraries=geometry,drawing,places&language=en&v=3.63"
                            onLoad={this.handleScriptLoad}
                        />
                        <div className="position-relative">
                            <Input
                                id='autocomplete'
                                type="text"
                                value={this.state.search}
                                disabled={this.state.fetchingCoordinates}
                                onChange={event => {
                                    this.setState({ search: [event.target.value] });
                                }}
                            />
                            {this.state.fetchingCoordinates && (
                                <div className="position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                                    <div className="spinner-border spinner-border-sm text-primary" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            )}
                        </div>
                        {this.state.fetchingCoordinates && (
                            <small className="text-muted d-block mt-2">
                                <i className="simple-icon-hourglass mr-1"></i>
                                Searching for polygon coordinates...
                            </small>
                        )}
                    </div>


                    {
                        list && list.areas && Object.keys(list.areas).map(areaTitle => {
                            return (
                                <div id={areaTitle} key={areaTitle}>
                                    <Card className={collaps[areaTitle] ? "pb-3" : ""} style={{ cursor: 'auto' }}>
                                        <Row className='p-3 ' style={{ cursor: 'pointer' }} onClick={() => this.setState({ collaps: { [areaTitle]: !collaps[areaTitle] } })}>
                                            <span className=" handle ml-3 mr-3">
                                                <i className={collaps[areaTitle] ? "simple-icon-arrow-down" : "simple-icon-arrow-right"} />
                                            </span>
                                            <div>{areaTitle}</div>


                                        </Row>
                                        <Collapse isOpen={collaps[areaTitle]}>
                                            {
                                                (list.areas[areaTitle].list ? list.areas[areaTitle].list : list.areas[areaTitle]).map((area, index) => {
                                                    return (
                                                        <div id={index} key={index} className='pl-3 pr-3'>
                                                            <Row className='justify-content-between pl-5 pr-2 pb-1'>

                                                                {area.name ? area.name : area}

                                                                <span className="mr-1 ml-3 d-flex align-items-center justify-content-end gap-2" >
                                                                    <i className="simple-icon-trash mr-2"
                                                                        style={{ cursor: 'pointer' }}
                                                                        onClick={() => {
                                                                            let deletedlocations = list?.deletedlocations || []
                                                                            deletedlocations.push(area.place_id);

                                                                            let areas_list = list?.areas_list?.filter(r => area.place_id !== r.id);
                                                                            let areas = list?.areas || {};

                                                                            const newlist = areas[areaTitle].list || areas[areaTitle];
                                                                            newlist.splice(index, 1);
                                                                            if (!newlist.length) {
                                                                                delete areas[areaTitle];
                                                                            }
                                                                            this.setState({ list: { ...list, deletedlocations, areas_list, areas } })
                                                                        }} />
                                                                    {area?.place_id && <i className="simple-icon-eye" style={{ cursor: 'pointer' }} onClick={async () => {
                                                                        let mapref = await firestore().collection('servingLocations').doc(area?.place_id).get()
                                                                        if (mapref.exists) {
                                                                            this.setState({ selectedArea: { ...area, pathCoordinates: mapref.data()?.geojson } })
                                                                        } else {
                                                                            let coordinates;
                                                                            let geojson = list.allLocations?.[area?.place_id]?.geojson
                                                                            if (geojson?.type === "MultiPolygon") {
                                                                                coordinates = {}
                                                                                geojson && geojson.coordinates && geojson.coordinates.map(recc => {
                                                                                    let polys = recc?.[0]?.reduce((val, currnetVal) => {
                                                                                        let latitude = currnetVal?.[1]
                                                                                        let longitude = currnetVal?.[0]
                                                                                        val.push({ latitude, longitude })
                                                                                        return val
                                                                                    }, [])
                                                                                    return coordinates[makeid()] = polys
                                                                                })
                                                                            } else {
                                                                                coordinates = geojson?.coordinates?.[0]?.reduce((val, currnetVal) => {
                                                                                    let latitude = currnetVal?.[1]
                                                                                    let longitude = currnetVal?.[0]
                                                                                    val.push({ latitude, longitude })
                                                                                    return val
                                                                                }, [])
                                                                            }

                                                                            this.setState({ selectedArea: { ...area, pathCoordinates: { ...geojson, coordinates } } })
                                                                        }
                                                                    }} />}

                                                                </span>

                                                            </Row>
                                                        </div>

                                                    )
                                                })
                                            }
                                        </Collapse>

                                    </Card>

                                </div>

                            )
                        })
                    }
                    {
                        list && <div className='mt-4'>
                            <Label>{list.type === 'onsite' ? 'Enter buffer time for this group:' : 'Enter estimated arrival time for this group:'}</Label>
                            <InputGroup className='mb-4'>
                                <Input
                                    placeholder={list.time && list.time.label === 'day' ? '1 day' : '10 min'}
                                    type='number'
                                    id='estimatedTime'
                                    value={list.time && list.time.value}
                                    onChange={(e) => {
                                        if (list.time) {
                                            list.time.value = e.target.value
                                            // Preserve existing label or default to 'min'
                                            if (!list.time.label) {
                                                list.time.label = 'min'
                                            }
                                        }
                                        else {
                                            list.time = { value: e.target.value, label: 'min' }
                                        }
                                        this.setState({ list })
                                    }}
                                />
                                <UncontrolledDropdown addonType="append">
                                    <DropdownToggle caret outline color="primary">
                                        {
                                            list.time && list.time.label ? list.time.label : 'min'
                                        }
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        {
                                            ['min', 'day'].map(item => {
                                                return (
                                                    <DropdownItem key={item} onClick={() => {
                                                        if (list.time) {
                                                            list.time.label = item
                                                        }
                                                        else {
                                                            list.time = { label: item }
                                                        }
                                                        this.setState({ list })
                                                    }

                                                    }>
                                                        {item}
                                                    </DropdownItem>
                                                )
                                            })
                                        }

                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </InputGroup>

                        </div>
                    }
                    <div className='mt-4'>
                        <Label>Minimum order value:</Label>
                        <Input
                            placeholder={'100 AED'}
                            type='number'
                            id='minOrder'
                            value={list && list.minOrder}
                            onChange={(e) => {
                                list.minOrder = e.target.value
                                this.setState({ list })
                            }}
                        />
                    </div>
                    {/* {list.type === 'onsite' && <div className='mt-4'>
                        <Label className='mb-0'>Capacity:</Label>
                        <div className='text-muted mb-2'>Enter number of people that can wash at the same time</div>
                        <Input
                            placeholder={'Enter capacity'}
                            type='number'
                            id='capacity'
                            value={list && list.capacity}
                            onChange={(e) => {
                                list.capacity = e.target.value
                                this.setState({ list })
                            }}
                        />
                    </div>} */}
                    {list.type === 'onsite' && <div className='mt-4'>
                        <Label className='mb-0'>Location Image:</Label>
                        <div className='text-muted mb-2'>Upload an image of the onsite location</div>
                        <ImageUploader
                            className={'w-100'}
                            withIcon={true}
                            label={'Max file size: 15mb, accepted: jpg|gif|png'}
                            buttonText='Choose image'
                            onChange={(picture) => this.onDrop(picture, 'locationImage')}
                            imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg']}
                            maxFileSize={15728640}
                            withPreview={true}
                            singleImage={true}
                            defaultImages={list && list.locationImage ? (Array.isArray(list.locationImage) ? list.locationImage : [list.locationImage]) : []}
                        />
                    </div>}

                    {list?.type !== 'onsite' && (
                        <div className='mt-4 d-flex align-items-center justify-content-between'>
                            <Label className={'m-0'} >Enable Package wash for this group</Label>
                            <Switch
                                className="custom-switch custom-switch-primary"
                                checked={list?.supportSubscriptions}
                                onChange={switchCheckedPrimary => {
                                    list.supportSubscriptions = switchCheckedPrimary
                                    this.setState({ list })

                                }}
                            />
                        </div>
                    )}

                </ModalBody>
                <ModalFooter>
                    <Button color='danger' onClick={() => {
                        this.cleanupPreviewURLs();
                        this.setState({ list: false, pictures: {} });
                    }}>Cancel</Button>
                    <Button disabled={!list || !list.areas} onClick={() => this.addList()}>Save</Button>
                </ModalFooter>


            </Modal>
        )
    }
    addList() {
        let { list, locations, pictures } = this.state
        let { selectedOutlet } = this.props
        let post = {
            areas_list: list?.areas_list || [],
            areas: list.areas,
            time: list.time ? list.time : {
                label: "min",
                value: "30"
            },
            minOrder: list.minOrder ? list.minOrder : false,
            // capacity: list.capacity ? list.capacity : null,
            type: list.type ? list.type : 'normal',
            washer_id: selectedOutlet.key,
            supportSubscriptions: list?.supportSubscriptions || false,
            recoveryServiceEnabled: list?.recoveryServiceEnabled || false,
            pickupAndDropoffPrice: list?.pickupAndDropoffPrice || null,
            pickupOnlyPrice: list?.pickupOnlyPrice || null
        }

        // Preserve existing locationImage if it hasn't been changed
        if (list.locationImage && (!pictures.locationImage || !pictures.locationImage[0]?.data)) {
            post.locationImage = list.locationImage;
        }

        let key = selectedOutlet.key
        let locationID = list?.id || firestore().collection('washers').doc(key).collection('locations').doc().id;

        firestore().collection('washers').doc(key).collection('locations').doc(locationID).set(post).then((result) => {
            post.id = locationID
            locations[locationID] = post

            // Upload images only if they are new (have 'data' property, not just existing URLs)
            Object.keys(pictures || {})?.forEach(fieldKey => {
                const fieldPictures = pictures?.[fieldKey];
                // Check if this is a new image upload (has data blob) vs existing image (just URL)
                const isNewImage = fieldPictures && fieldPictures.length > 0 && fieldPictures[0]?.data;
                if (isNewImage) {
                    uploadPicture({
                        pictures: fieldPictures,
                        collection: 'washers',
                        parentId: key,
                        subCollection: 'locations',
                        documentID: locationID,
                        childId: fieldKey,
                        type: 'subCollection'
                    });
                }
            });

            if (list?.deletedlocations?.length) {
                list.deletedlocations.map(async (r) => {
                    await firestore().collection('servingLocations').doc(r).update({ workers: firestore.FieldValue.arrayRemove(key), })
                })
            }
            if (list?.allLocations) {
                Object.keys(list?.allLocations || {}).map(async (r) => {
                    let location = list?.allLocations?.[r]
                    let coordinates;

                    console.log('Processing location for Firebase:', {
                        place_id: location?.place_id,
                        geojsonType: location?.geojson?.type,
                        coordinatesStructure: location?.geojson?.coordinates
                    });

                    if (location?.geojson?.type === "MultiPolygon") {
                        coordinates = {}
                        location.geojson && location.geojson.coordinates && location.geojson.coordinates.map((recc, index) => {
                            let polys = recc?.[0]?.reduce((val, currnetVal) => {
                                let latitude = currnetVal?.[1]
                                let longitude = currnetVal?.[0]
                                val.push({ latitude, longitude })
                                return val
                            }, [])
                            return coordinates["polygon_" + String(index)] = polys
                        })
                    } else if (location?.geojson?.type === "Polygon") {
                        // Polygon coordinates should be [[[lng, lat], [lng, lat], ...]]
                        const ringCoordinates = location?.geojson?.coordinates?.[0];

                        if (Array.isArray(ringCoordinates)) {
                            coordinates = ringCoordinates.reduce((val, currnetVal) => {
                                // Check if coordinate is in array format [lng, lat]
                                if (Array.isArray(currnetVal) && currnetVal.length >= 2) {
                                    let latitude = currnetVal[1]
                                    let longitude = currnetVal[0]
                                    val.push({ latitude, longitude })
                                }
                                return val
                            }, [])
                        } else {
                            console.error('Invalid Polygon coordinates structure:', ringCoordinates);
                            coordinates = []
                        }
                    } else if (location?.geojson?.type === "Point") {
                        // Point coordinates for onsite locations: [lng, lat]
                        const pointCoordinates = location?.geojson?.coordinates;
                        if (Array.isArray(pointCoordinates) && pointCoordinates.length >= 2) {
                            coordinates = [{
                                latitude: pointCoordinates[1],
                                longitude: pointCoordinates[0]
                            }]
                        } else {
                            // Fallback: check if coordinates is already in {latitude, longitude} format
                            coordinates = Array.isArray(pointCoordinates) && pointCoordinates.length > 0 && pointCoordinates[0]?.latitude 
                                ? pointCoordinates 
                                : []
                        }
                    } else {
                        coordinates = []
                    }

                    // Store geojson with converted coordinates for Firebase
                    let post = {
                        display_name: location?.display_name,
                        geojson: {
                            type: location?.geojson?.type,
                            coordinates  // Use converted {latitude, longitude} format for Firebase
                        },
                        place_id: location?.place_id,
                    }

                    // Only add optional fields if they exist (avoid Firebase undefined errors)
                    if (location?.osm_id !== undefined) {
                        post.osm_id = location.osm_id;
                    }
                    if (location?.osm_type !== undefined) {
                        post.osm_type = location.osm_type;
                    }
                    if (location?.type !== undefined) {
                        post.type = location.type;
                    }
                    if (location?.class !== undefined) {
                        post.class = location.class;
                    }

                    await firestore().collection('servingLocations').doc(r).set({ ...post, workers: firestore.FieldValue.arrayUnion(key), }, { merge: true })
                })
            }
            this.cleanupPreviewURLs();
            this.setState({ list: false, locations, pictures: {} })
        })
    }
    handleScriptLoad() {
        // Declare Options For Autocomplete 
        // var circle = new google.maps.Circle(
        //     { center: { lat: 25.1874756, lng: 55.2529987 }, radius: 20000 });
        var options = {
            types: ['geocode', 'establishment'],
            // types: ['(regions)'],
            componentRestrictions: { country: 'ae' },
            // language: 'en'
        };

        // Initialize Google Autocomplete 
        /*global google*/
        this.autocomplete = new google.maps.places.Autocomplete(
            document.getElementById('autocomplete'),
            options);
        // this.autocomplete.setBounds(circle.getBounds());

        // Avoid paying for data that you don't need by restricting the 
        // set of place fields that are returned to just the address
        // components and formatted address
        this.autocomplete.setFields(['address_components',
            'formatted_address', 'geometry', 'type', 'name', 'vicinity', 'place_id']);
        // Fire Event when a suggested name is selected
        this.autocomplete.addListener('place_changed',
            this.handlePlaceSelect);
    }

    async handlePlaceSelect() {
        // Show loading indicator
        this.setState({ fetchingCoordinates: true });

        try {
            const country = localStorage.getItem('country');
            const addressObject = this.autocomplete.getPlace();

            // Validate that we have geometry information
            if (!addressObject || !addressObject.geometry) {
                console.error('No geometry information found for selected location');
                createNotification('error', 'Unable to retrieve location information. Please try again.', 'Error');
                this.setState({ fetchingCoordinates: false });
                return;
            }

            const mapArea = addressObject.name;
            let { formatted_address, name, geometry, types, address_components } = addressObject;
            const { list } = this.state;

            // For onsite locations, skip polygon fetching and open map with marker only
            if (list?.type === 'onsite') {
                const polygon = `onsite_${Date.now()}_${makeid()}`;
                const existingPlace = this.searchId(this.state.locations, polygon);

                if (existingPlace) {
                    this.setState({ fetchingCoordinates: false });
                    return createNotification('error', 'This location is already added in another cluster!', 'Error');
                }

                // Create point-based location data for onsite
                const pointData = {
                    display_name: mapArea,
                    place_id: polygon,
                    geojson: {
                        type: 'Point',
                        coordinates: [geometry.location.lng(), geometry.location.lat()]
                    },
                    lat: geometry.location.lat().toString(),
                    lon: geometry.location.lng().toString(),
                    type: 'onsite_point',
                    class: 'place'
                };

                // Convert to the format expected by the map
                const coordinates = [{ 
                    latitude: geometry.location.lat(), 
                    longitude: geometry.location.lng() 
                }];

                // Create center point from the selected location's geometry
                const centerPoint = {
                    latitude: geometry.location.lat(),
                    longitude: geometry.location.lng()
                };

                this.setState({
                    list,
                    search: '',
                    fetchingCoordinates: false,
                    selectedArea: {
                        name: mapArea,
                        pathCoordinates: { 
                            type: 'Point', 
                            coordinates: coordinates 
                        },
                        newLocation: { 
                            data: pointData, 
                            addressObject, 
                            paramArray: formatted_address?.split(country === 'Egypt' ? ', ' : ' - '), 
                            geometry, 
                            polygon, 
                            mapArea, 
                            list,
                            isOnsite: true,
                            centerPoint // Pass the center point explicitly
                        }
                    }
                });

                return;
            }

            // Validate country - ensure we're in UAE
            const countryComponent = address_components?.find(comp => comp.types.includes('country'));
            if (countryComponent && countryComponent.short_name !== 'AE') {
                console.warn('Selected location is not in UAE:', countryComponent.short_name);
                createNotification('error', 'Please select a location within UAE', 'Error');
                this.setState({ search: '', fetchingCoordinates: false });
                return;
            }

            const paramArray = formatted_address?.split(country === 'Egypt' ? ', ' : ' - ');
            let data;

            if (types?.includes('airport')) {
                formatted_address = name
            }

            // Detect if this is a building/tower search
            const isBuildingSearch = types?.includes('premise') ||
                types?.includes('establishment') ||
                name?.toLowerCase().includes('tower') ||
                name?.toLowerCase().includes('building') ||
                name?.toLowerCase().includes('mall') ||
                formatted_address?.toLowerCase().includes('tower') ||
                formatted_address?.toLowerCase().includes('building');

            console.log('Selected location:', {
                name: mapArea,
                address: formatted_address,
                lat: geometry.location.lat(),
                lng: geometry.location.lng(),
                country: countryComponent?.short_name,
                types: types,
                isBuildingSearch
            });

            // Enhanced search for small areas like mall parking, buildings, etc.
            let searchQueries;

            if (isBuildingSearch) {
                // For building/tower searches, use more specific queries
                searchQueries = [
                    name, // Start with the exact name
                    `${name} tower`,
                    `${name} building`,
                    `${name} UAE`,
                    `${name} Abu Dhabi`,
                    `${name} Dubai`,
                    formatted_address,
                ];
            } else {
                // For general area searches, use broader queries
                searchQueries = [
                    formatted_address,
                    `${formatted_address} parking`,
                    `${formatted_address} building`,
                    `${formatted_address} mall`,
                    `${formatted_address} complex`,
                    name,
                    `${name} parking`,
                    `${name} building`,
                    `${name} mall`,
                    `${name} complex`
                ];
            }

            let polygonResults;
            let foundData = false;

            // Helper function to calculate distance between two points in kilometers
            const calculateDistance = (lat1, lon1, lat2, lon2) => {
                const R = 6371; // Radius of the earth in km
                const dLat = (lat2 - lat1) * Math.PI / 180;
                const dLon = (lon2 - lon1) * Math.PI / 180;
                const a =
                    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                    Math.sin(dLon / 2) * Math.sin(dLon / 2);
                const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                return R * c; // Distance in km
            };

            const selectedLat = geometry.location.lat();
            const selectedLng = geometry.location.lng();

            // Use stricter distance for building searches (buildings should be very close to selected point)
            const MAX_DISTANCE_KM = isBuildingSearch ? 1 : 50; // 1km for buildings, 50km for areas

            // Try multiple search queries to find polygon data
            for (const query of searchQueries) {
                try {
                    console.log(`Attempting Nominatim search with query: ${query}`);
                    // Add UAE country code to limit results to UAE only
                    polygonResults = await axios.get(`https://nominatim.openstreetmap.org/search.php?q=${encodeURIComponent(query)}&countrycodes=ae&polygon_geojson=1&format=json`);

                    console.log(`Nominatim results for "${query}":`, polygonResults?.data?.length || 0, 'results');

                    // Filter candidates based on search type
                    let candidates;

                    if (isBuildingSearch) {
                        // For buildings/towers, ONLY accept building-specific polygon types
                        candidates = polygonResults?.data?.filter(r =>
                            (r.class === 'building' ||
                                (r.class === 'amenity' && ['parking', 'commercial'].includes(r.type)) ||
                                (r.class === 'shop' && r.type === 'mall')) &&
                            ["Polygon", "MultiPolygon"]?.includes(r?.geojson?.type)
                        ) || [];

                        console.log(`Building search: Found ${candidates.length} building-specific polygons`);
                    } else {
                        // For general area searches, accept various types
                        candidates = polygonResults?.data?.filter(r =>
                            ['boundary', 'place', 'aeroway', 'landuse', 'amenity', 'shop', 'tourism', 'leisure'].includes(r.class) &&
                            ['town', 'suburb', 'administrative', 'neighbourhood', 'aerodrome', 'residential', 'commercial', 'retail', 'parking', 'mall', 'building', 'shopping_centre'].includes(r.type) &&
                            ["Polygon", "MultiPolygon"]?.includes(r?.geojson?.type)
                        ) || [];
                    }

                    // Find the closest candidate to our selected location
                    for (const candidate of candidates) {
                        const candidateLat = parseFloat(candidate.lat);
                        const candidateLng = parseFloat(candidate.lon);
                        const distance = calculateDistance(selectedLat, selectedLng, candidateLat, candidateLng);

                        console.log(`Candidate found: ${candidate.display_name}`, {
                            distance: `${distance.toFixed(2)} km`,
                            lat: candidateLat,
                            lng: candidateLng
                        });

                        // Only accept if within reasonable distance
                        if (distance <= MAX_DISTANCE_KM) {
                            data = candidate;
                            console.log('✓ Polygon data accepted (within distance threshold):', {
                                query,
                                class: data.class,
                                type: data.type,
                                geojsonType: data.geojson?.type,
                                display_name: data.display_name,
                                distance: `${distance.toFixed(2)} km`
                            });
                            foundData = true;
                            break;
                        } else {
                            console.log('✗ Polygon data rejected (too far from selected location):', {
                                distance: `${distance.toFixed(2)} km`,
                                maxAllowed: `${MAX_DISTANCE_KM} km`
                            });
                        }
                    }

                    if (foundData) break;
                } catch (error) {
                    console.error(`Nominatim search failed for query: ${query}`, error);
                    continue;
                }
            }

            if (!foundData) {
                console.log('No polygon data found in initial search queries, trying alternative approaches...');
            }

            // If still no data found, try alternative search approaches
            // Skip alternative search for buildings - we don't want to fallback to larger areas
            if (!foundData && !isBuildingSearch) {
                try {
                    console.log('Trying alternative search with modified address format...');
                    formatted_address = formatted_address?.split(' - ')?.join(' , ');
                    // Add UAE country code filter
                    polygonResults = await axios.get(`https://nominatim.openstreetmap.org/search.php?q=${encodeURIComponent(formatted_address)}&countrycodes=ae&polygon_geojson=1&format=json`);

                    console.log('Alternative search results:', polygonResults?.data?.length || 0, 'results');

                    const candidates = polygonResults?.data?.filter(r =>
                        ['boundary', 'place', 'aeroway', 'landuse', 'amenity', 'shop', 'tourism', 'leisure'].includes(r.class) &&
                        ['town', 'suburb', 'administrative', 'neighbourhood', 'aerodrome', 'residential', 'commercial', 'retail', 'parking', 'mall', 'building', 'shopping_centre'].includes(r.type) &&
                        ["Polygon", "MultiPolygon"]?.includes(r?.geojson?.type)
                    ) || [];

                    // Validate distance for alternative search results too
                    for (const candidate of candidates) {
                        const candidateLat = parseFloat(candidate.lat);
                        const candidateLng = parseFloat(candidate.lon);
                        const distance = calculateDistance(selectedLat, selectedLng, candidateLat, candidateLng);

                        if (distance <= MAX_DISTANCE_KM) {
                            data = candidate;
                            console.log('✓ Alternative search: Polygon data accepted:', {
                                display_name: data.display_name,
                                distance: `${distance.toFixed(2)} km`
                            });
                            break;
                        }
                    }

                    if (!data) {
                        console.log('Attempting reverse geocode lookup using viewport center...');
                        // Try to get place_id and search by it
                        const bound = [
                            {
                                latitude: addressObject.geometry.viewport.getNorthEast().lat(),
                                longitude: addressObject.geometry.viewport.getNorthEast().lng(),
                            },
                            {
                                latitude: addressObject.geometry.viewport.getSouthWest().lat(),
                                longitude: addressObject.geometry.viewport.getNorthEast().lng(),
                            },
                            {
                                latitude: addressObject.geometry.viewport.getSouthWest().lat(),
                                longitude: addressObject.geometry.viewport.getSouthWest().lng(),
                            },
                            {
                                latitude: addressObject.geometry.viewport.getNorthEast().lat(),
                                longitude: addressObject.geometry.viewport.getSouthWest().lng(),
                            },
                        ];
                        const center = getCenter(bound);
                        console.log('Viewport center:', center);

                        let place_id = await getPlaceId(center.latitude, center.longitude, name)
                        if (place_id) {
                            console.log('Found place_id via reverse geocode:', place_id);
                            const polygonResults = await axios.get(`https://nominatim.openstreetmap.org/details.php?place_id=${place_id}&polygon_geojson=1&format=json`);
                            data = { ...polygonResults?.data, display_name: polygonResults?.data?.localname, geojson: polygonResults?.data?.geometry }

                            if (data && data.geojson) {
                                console.log('Successfully retrieved polygon data via place_id lookup');
                            }
                        } else {
                            console.log('Could not find place_id via reverse geocode');
                        }
                    }
                } catch (error) {
                    console.error('Alternative search failed:', error);
                }
            } else if (!foundData && isBuildingSearch) {
                console.log('Building/tower search: No specific building polygon found. Will open manual drawing mode.');
                createNotification('info', 'No building polygon found. Please draw the building area manually on the map.', 'Info');
            }

            // Final validation: ensure polygon is actually in UAE by checking distance
            if (data && data.geojson && ["Polygon", "MultiPolygon"].includes(data.geojson.type)) {
                const dataLat = parseFloat(data.lat);
                const dataLng = parseFloat(data.lon);
                const finalDistance = calculateDistance(selectedLat, selectedLng, dataLat, dataLng);

                if (finalDistance > MAX_DISTANCE_KM) {
                    console.warn('Final validation failed: Polygon too far from selected location', {
                        selectedLocation: { lat: selectedLat, lng: selectedLng },
                        polygonLocation: { lat: dataLat, lng: dataLng },
                        distance: `${finalDistance.toFixed(2)} km`,
                        polygonDisplayName: data.display_name
                    });
                    createNotification('warning', `Found polygon data is too far from selected location (${finalDistance.toFixed(0)}km away). Please draw the area manually.`, 'Warning');
                    data = null; // Reject this data
                }

                // Additional validation for building searches: ensure we got a building polygon
                if (isBuildingSearch && data && data.class !== 'building') {
                    console.warn('Final validation failed: Expected building polygon but got', data.class, data.type);
                    createNotification('info', `Found ${data.type} area instead of specific building. Please draw the building area manually.`, 'Info');
                    data = null; // Reject non-building data for building searches
                }
            }

            // If no polygon data found, open map for manual drawing centered on selected location
            if (!data || !data.geojson || !["Polygon", "MultiPolygon"].includes(data.geojson.type)) {
                // Create a fallback data structure for manual polygon drawing
                const displaySuffix = isBuildingSearch ? '(Building - Manually Drawn)' : '(Manually Drawn)';
                const fallbackData = {
                    display_name: `${mapArea} ${displaySuffix}`,
                    place_id: `manual_${Date.now()}`,
                    geojson: {
                        type: 'Point',
                        coordinates: [geometry.location.lng(), geometry.location.lat()]
                    },
                    // Add metadata for manually drawn locations
                    lat: geometry.location.lat().toString(),
                    lon: geometry.location.lng().toString(),
                    type: isBuildingSearch ? 'manual_building' : 'manual_boundary', // Mark type based on search
                    class: isBuildingSearch ? 'building' : 'boundary',
                    // Don't include osm_id and osm_type - they will be undefined and cause Firebase errors
                };

                // Create center point from the selected location's geometry
                const centerPoint = {
                    latitude: geometry.location.lat(),
                    longitude: geometry.location.lng()
                };

                this.setState({
                    list,
                    search: '',
                    fetchingCoordinates: false,
                    selectedArea: {
                        name: mapArea,
                        pathCoordinates: {
                            type: 'Point',
                            coordinates: [centerPoint] // Set center for the map
                        },
                        newLocation: {
                            data: fallbackData,
                            addressObject,
                            paramArray,
                            geometry,
                            polygon: fallbackData.place_id,
                            mapArea,
                            list,
                            isManualDrawing: true, // Flag to indicate manual drawing is required
                            centerPoint // Pass the center point explicitly
                        }
                    }
                });

                console.log('No polygon data found, opening map for manual drawing at:', {
                    lat: geometry.location.lat(),
                    lng: geometry.location.lng(),
                    location: mapArea
                });

                return;
            }

            const polygon = String(data?.place_id);
            const existingPlace = this.searchId(this.state.locations, polygon);

            if (existingPlace) {
                this.setState({ fetchingCoordinates: false });
                return createNotification('error', 'This location is already added in another cluster!', 'Error');
            }

            let coordinates;
            let geojson = data?.geojson;

            if (geojson?.type === "MultiPolygon") {
                coordinates = {}
                geojson && geojson.coordinates && geojson.coordinates.map(recc => {
                    let polys = recc?.[0]?.reduce((val, currnetVal) => {
                        let latitude = currnetVal?.[1]
                        let longitude = currnetVal?.[0]
                        val.push({ latitude, longitude })
                        return val
                    }, [])
                    return coordinates[makeid()] = polys
                })
            } else if (geojson?.type === 'Polygon') {
                coordinates = geojson?.coordinates?.[0]?.reduce((val, currnetVal) => {
                    let latitude = currnetVal?.[1]
                    let longitude = currnetVal?.[0]
                    val.push({ latitude, longitude })
                    return val
                }, [])
            } else {
                coordinates = [{ latitude: geometry?.location?.lat(), longitude: geometry?.location?.lng(), }]
            }

            this.setState({
                list,
                search: '',
                fetchingCoordinates: false,
                selectedArea: {
                    name: mapArea,
                    pathCoordinates: { ...geojson, coordinates },
                    newLocation: { data, addressObject, paramArray, geometry, polygon, mapArea, list }
                }
            })
        } catch (error) {
            // Handle any unexpected errors and reset loading state
            console.error('Error in handlePlaceSelect:', error);
            createNotification('error', 'An error occurred while processing the location. Please try again.', 'Error');
            this.setState({ fetchingCoordinates: false, search: '' });
        }
    }

    async addLocation(locationData) {
        let _this = this

        // If locationData is undefined (onsite location without coordinates), get from selectedArea
        if (!locationData) {
            const { selectedArea } = this.state;
            if (selectedArea?.newLocation) {
                locationData = selectedArea.newLocation;
            } else {
                console.error('No location data available');
                return;
            }
        }

        // Check if locationData is just an array of coordinates (manually drawn)
        if (Array.isArray(locationData)) {
            // When called with just coordinates array from manual drawing
            const { selectedArea } = this.state;
            const newLocationData = selectedArea?.newLocation;

            if (newLocationData) {
                // Update the geojson with the manually drawn coordinates
                newLocationData.data.geojson = {
                    type: 'Polygon',
                    coordinates: [locationData] // locationData is the array of [lng, lat] pairs
                };

                // Now call addLocation recursively with the full data structure
                return this.addLocation(newLocationData);
            }
        }

        let { data, addressObject, paramArray, geometry, polygon, mapArea, list, isManualDrawing, isOnsite } = locationData

        // Validate that manually drawn polygons have proper coordinates
        if (isManualDrawing && data?.geojson && !isOnsite) {
            // Ensure coordinates are in correct format: [[[lng, lat], [lng, lat], ...]]
            if (data.geojson.type === 'Polygon' && Array.isArray(data.geojson.coordinates)) {
                // Coordinates should already be in correct format from above
                console.log('Manual polygon coordinates validated:', {
                    type: data.geojson.type,
                    coordinatesCount: data.geojson.coordinates[0]?.length || 0
                });
            }
        }

        const polygonTitle = data?.display_name;
        list.areas_list = list.areas_list || [];
        list.areas_list.push({ id: polygon, title: polygonTitle });
        list.allLocations = list?.allLocations || {};
        list.allLocations[polygon] = data;

        console.log('Storing location data:', {
            polygon,
            display_name: data?.display_name,
            geojsonType: data?.geojson?.type,
            coordinatesFormat: data?.geojson?.coordinates?.[0]?.[0], // Show first coordinate
            isManualDrawing
        });

        let address = addressObject?.address_components.reduce((value, currentValue) => {
            if (currentValue.types.includes("neighborhood")) {
                value.area = currentValue.short_name
            }
            if (!value.area && currentValue.types.includes("sublocality")) {
                value.area = currentValue.short_name
            }
            if (currentValue.types.includes("route")) {
                value.street = currentValue.short_name
            }
            if (currentValue.types.includes("administrative_area_level_1")) {
                value.emirate = currentValue.short_name
            }

            return value
        }, {})
        
        // For onsite locations, use location name as area title if paramArray is too short
        const areaTitle = isOnsite && paramArray.length <= 1 
            ? mapArea || 'Onsite Location' 
            : paramArray.length > 1 ? paramArray[paramArray.length - 2] : null;
        
        if (paramArray.length > 1 || (isOnsite && areaTitle)) {
            const res = await axios.get('https://maps.googleapis.com/maps/api/geocode/json', {
                params: {
                    place_id: addressObject.place_id,
                    key: 'AIzaSyCExglJjHXgXzSGHJB1NmLll7NgjOG8_bc',
                    language: 'ar',
                },
            });
            const addressComponents = res.data.results[0].address_components;
            const nameAr = addressComponents?.[0]?.short_name || '';
            const sublocalityAr = addressComponents?.find(item => item?.types?.includes('locality') || item?.types?.includes('administrative_area_level_1'))?.short_name || '';

            const newArea = {
                place_id: polygon,
                name: mapArea,
                name_ar: nameAr,
                latitude: geometry.location.lat(),
                longitude: geometry.location.lng(),
                viewport: {
                    south_west: {
                        lng: addressObject.geometry.viewport.getSouthWest().lng(),
                        lat: addressObject.geometry.viewport.getSouthWest().lat(),
                    },
                    north_East: {
                        lng: addressObject.geometry.viewport.getNorthEast().lng(),
                        lat: addressObject.geometry.viewport.getNorthEast().lat(),
                    },
                },
            };

            if (list.areas && list.areas[areaTitle] && list.areas[areaTitle].list) {
                list.areas[areaTitle].list.push(newArea);
            } else if (list.areas) {
                list.areas[areaTitle] = {
                    list: [newArea],
                    name_ar: sublocalityAr,
                    name: address?.emirate || areaTitle,
                };
            } else {
                list.areas = {
                    [areaTitle]: {
                        list: [newArea],
                        name: address?.emirate || areaTitle,
                        name_ar: sublocalityAr,
                    },
                };
            }
            _this.setState({
                list,
                search: '',
                collaps: { [areaTitle]: true },
                selectedArea: false
            });
        }
    }


}

const mapStateToProps = (state) => ({
    provider: state.providers?.provider || {}
});

export default connect(mapStateToProps)(Start);